class JoueurModel {
    constructor(pseudo,nom,prenom,role,video,anniversaire,lienTemporaire,inactif,fincontrat){
        this.pseudo = pseudo
        this.nom = nom
        this.prenom = prenom
        this.role = role
        this.video = video
        this.anniversaire = anniversaire
        this.lienTemporaire = lienTemporaire
        this.inactif = inactif
        this.fincontrat = fincontrat
    }

    static fromJSON(json) {
        return new JoueurModel(json.pseudo, json.nom, json.prenom, json.role, json.video, json.anniversaire, json.lienTemporaire, json.inactif, json.fincontrat);
    }

    getJoursJusquAnniversaire() {
        const aujourdhui = new Date();
        const anniversaire = new Date(this.anniversaire);
        const anniversaireCetteAnnee = new Date(
            aujourdhui.getFullYear(),
            anniversaire.getMonth(),
            anniversaire.getDate()
        );

        if (anniversaireCetteAnnee < aujourdhui) {
            anniversaireCetteAnnee.setFullYear(aujourdhui.getFullYear() + 1);
        }

        const diff = anniversaireCetteAnnee - aujourdhui;
        return Math.ceil(diff / (1000 * 60 * 60 * 24));
    }

}

export default JoueurModel;